/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_UnreadableInputs */



/**
* | output |
* | --- |
* | "{count} reports could not be read, so they are excluded from the three totals above." |
*
* @param {Partner_Billing_Board_UnreadableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_unreadable = /** @type {((inputs: Partner_Billing_Board_UnreadableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_UnreadableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Berichte konnten nicht gelesen werden und sind aus den drei Summen oben ausgenommen.`)
	return /** @type {LocalizedString} */ (`${i?.count} reports could not be read, so they are excluded from the three totals above.`)
});